import BaseHeader from '@bnnvara/headers';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

const ProfileHeaderLoggedIn = forwardRef(({ textColor, page }, ref) => {
  const mobileImage = page.backgroundImageMobile || page.backgroundImage;

  return (
    <BaseHeader
      ref={ref}
      title=""
      image={page.backgroundImage}
      mobileImage={mobileImage}
      color={textColor}
    />
  );
});

ProfileHeaderLoggedIn.defaultProps = {
  textColor: 'white',
  page: {
    callToActionText: null,
    callToActionUrl: null,
  },
};
ProfileHeaderLoggedIn.propTypes = {
  textColor: PropTypes.string,
  page: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    backgroundImage: PropTypes.string.isRequired,
    backgroundImageMobile: PropTypes.string.isRequired,
    logoUrl: PropTypes.string.isRequired,
    callToActionText: PropTypes.string,
    callToActionUrl: PropTypes.string,
  }),
};

export default ProfileHeaderLoggedIn;
